import { SafeBaseObject } from "@app/core/models/base-object.models";
import { DateTime } from "luxon";

export class ResManifest extends SafeBaseObject {
  iD: number = 0;
  [key: string]: any;
  prePost = false;
  isUpgraded = false;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
  override updateData(data: any): void {
    this.addMangledProperty(data);
    this.addBooleanProperty('prePost', data, 'PrePost');
    this.addBooleanProperty('isUpgraded', data, 'IsUpgraded');

    if (this['pre Remark'] != undefined) this.formattedPreRemark = this.formatFullManifestRemark(this['pre Remark']);
    if (this['post Remark'] != undefined) this.formattedPostRemark = this.formatFullManifestRemark(this['post Remark']);
  }

  formatFullManifestRemark(remark: string): string {
    if (!remark) return '';
    return '<ul>' +
      remark.split('remark-separator').filter((r: string) => r.includes(': ')).map((r: string) => {
        const [option, remark] = r.split(': ');
        return `<li class="mb-3"><h6>${option}:</h6> <br>${remark}</li>`;
      }).join('')
      + '</ul>';
  }
}


export class ResSavedManifestHeader extends SafeBaseObject {
  iD: number = 0;
  [key: string]: any;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
  override updateData(data: any): void {
    this.addMangledProperty(data);
  }
}


export interface IResApiManifestVoyage {
  VoyageID: number;
  VoyageNumber: string;
}

export interface IResApiGetManifestParams {
  VoyageID?: number;
  ManifestType: string;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  BkgStatus?: string;
  PrePost?: string;
  PackageID?: number;
  PackageTravelDateID?: string;
  AllVoyages?: string;
  BkgID?: number;
  ServiceName?: string;
  ServiceTypeID?: number;
}

export interface IResApiGetSavedManifestsParams extends IResApiGetManifestParams {
  FileName?: string;
  CreatedBy?: string;
  Note?: string;
  PackageID?: number;
}

export interface IResApiOpenSavedManifestParams {
  ManifestSavedHdrID: number;
  BkgStatus?: string;
  PrePost?: string;
  PackageID?: number;
  PackageTravelDateID?: string;
}

export interface IResApiUpdateManifestHeaderParams {
  ManifestSavedHdrID: number;
  fileName: string;
  note: string;
}

export interface IResApiSaveManifestParams {
  VoyageID: number;
  ManifestType: string;
  FileName: string;
  Note?: string;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  PackageID?: number;
  PackageTravelDateID?: string;
}

export interface IResApiUpdateManifestParams {
  ManifestSavedHdrID: number;
}

export interface IResApiDeleteManifestParams {
  ManifestSavedHdrID: number;
}

export interface IResApiCompareManifestParams {
  ManifestSavedHdrID: number;
  CompareType: 'DELTA' | 'FULL';
  BkgStatus?: string;
  PrePost?: string;
}

export interface IResApiCompareTwoManifestsParams {
  ManifestType: string;
  ManifestOneHdrID: number;
  ManifestTwoHdrID: number;
  CompareType: 'DELTA' | 'FULL';
  BkgStatus?: string;
  PrePost?: string;
}

export enum ResSavedManifestSearchMode {
  Delta = 'DELTA',
  Full = 'FULL'
}

export interface IResApiGetFullManifestParams {
  VoyageID?: number;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  BkgStatus?: string;
  PrePost?: string;
}

export interface IResApiGetSavedFullManifestsParams extends IResApiGetFullManifestParams {
  FileName?: string;
  CreatedBy?: string;
  Note?: string;
  PackageID?: number;
}

export interface IResApiOpenSavedFullManifestParams {
  FullManifestSavedHdrID: number;
  BkgStatus?: string;
  PrePost?: string;
  PackageID?: number;
}

export interface IResApiUpdateFullManifestHeaderParams {
  FullManifestSavedHdrID: number;
  fileName: string;
  note: string;
}

export interface IResApiSaveFullManifestParams {
  VoyageID: number;
  FileName: string;
  Note?: string;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  PackageID?: number;
}

export interface IResApiUpdateFullManifestParams {
  FullManifestSavedHdrID: number;
}

export interface IResApiDeleteFullManifestParams {
  FullManifestSavedHdrID: number;
}